const included = [
  "One live weekly Consistency Corner gathering",
  "A gentle guided check-in",
  "Space to celebrate, reset and choose your next step",
  "Camera-optional participation",
  "A supportive room without pressure or judgment",
];

const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#e8463c] transition-colors";

export function Membership() {
  return (
    <section
      data-testid="cc-membership-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FFFFFF 0%, #EFF5F4 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[104px] md:pt-[124px] pb-[56px] md:pb-[76px] reveal">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
            Join the Corner
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[52px] leading-[1.1] tracking-tight text-[#1C1917] mb-10">
            A weekly place to keep showing up for what matters.
          </h2>

          <ul className="space-y-3 text-left max-w-md mx-auto mb-[24px]">
            {included.map((item, i) => (
              <li
                key={item}
                data-testid={`cc-included-${i}`}
                className="flex items-baseline gap-3 text-lg text-[#1C1917]"
              >
                <span aria-hidden className="text-[#159E9A]">&ndash;</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <p
            data-testid="cc-membership-clubhouse"
            className="text-lg md:text-xl leading-relaxed text-[#57534E] max-w-xl mx-auto mb-[16px]"
          >
            Members also have access to the private Consistency Corner House
            on Clubhouse, where encouragement, conversation and support
            continue between weekly gatherings.
          </p>

          <a
            href="mailto:lara@blueprint4joy.com?subject=Consistency%20Corner"
            data-testid="cc-membership-cta"
            className={btnPrimary}
          >
            Join Consistency Corner
          </a>
        </div>
      </div>
    </section>
  );
}
